import { StateCreator } from 'zustand';
import { NetworkActions, GalaxyStore } from '../types';
import { NetworkStats } from '../../models';

export interface NetworkSlice extends NetworkActions {}

export const createNetworkSlice: StateCreator<
  GalaxyStore,
  [],
  [],
  NetworkSlice
> = (set) => ({
  // Actions only - state is defined in main store
  updateNetworkStats: (stats: Partial<NetworkStats>) => set((state) => {
    const updatedNetwork = {
      ...state.network,
      lastUpdate: Date.now(),
    };

    if (stats.hashrate !== undefined) {
      updatedNetwork.hashrate = stats.hashrate;
    }

    if (stats.difficulty !== undefined) {
      updatedNetwork.difficulty = stats.difficulty;
    }

    if (stats.currentHeight !== undefined) {
      updatedNetwork.currentHeight = stats.currentHeight;
    }

    if (stats.nextAdjustment) {
      updatedNetwork.nextAdjustment = {
        blocksRemaining: stats.nextAdjustment.blocksRemaining,
        estimatedTime: stats.nextAdjustment.estimatedTime * 1000, // Convert to milliseconds
        estimatedChange: stats.nextAdjustment.estimatedChange,
      };
    }

    return {
      ...state,
      network: updatedNetwork,
    };
  }),
});